var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpecialInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4262_5459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.49609 18C14.4667 18 18.4961 13.9706 18.4961 9C18.4961 4.02944 14.4667 0 9.49609 0C4.52553 0 0.496094 4.02944 0.496094 9C0.496094 13.9706 4.52553 18 9.49609 18Z",
    fill: "#215D99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8288 5.44437C10.8288 6.18075 10.2318 6.7777 9.49544 6.7777C8.75906 6.7777 8.16211 6.18075 8.16211 5.44437C8.16211 4.70799 8.75906 4.11104 9.49544 4.11104C10.2318 4.11104 10.8288 4.70799 10.8288 5.44437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49609 9V12.5556",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4262_5459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.496094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialInfo);
export default __webpack_public_path__ + "static/media/specialInfo.206175ffb1977c95ebaddce0759ca538.svg";
export { ForwardRef as ReactComponent };